import LoadingHolder from './LoadingHolder';

export default LoadingHolder;
